import { Button, Form, Modal, notification } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import { createEmail } from "store/slices/emailsSlice";
import {
  getInstructors,
  selectAssignableInstructors,
} from "store/slices/instructorsSlice";
import EmailForm from "./email-form";
const NewEmailModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { email, loading } = useSelector((state) => state?.emails);
  const instructors = useSelector(selectAssignableInstructors);
  const { userData } = useSelector((state) => state?.auth);
  const open = isModalOpen && modalType === "new_email";

  useEffect(() => {
    if (open) dispatch(getInstructors(userData?._id));
  }, [dispatch, open]);

  const onSubmit = async (values) => {
    try {
      await dispatch(createEmail(values))?.unwrap();
      onClose();
    } catch (error) {
      notification?.error({
        message: t("emails.crud.form.error.failed"),
        description: error,
        role: "alert",
        duration: 3,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={<h4 style={{ textAlign: "center" }}>{t("emails.crud.form")}</h4>}
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("emails.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="email_form"
          disabled={loading}
        >
          {t("emails.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <EmailForm form={form} onSubmit={onSubmit} instructors={instructors} />
    </Modal>
  );
};

export default NewEmailModal;
